import "bootstrap/dist/css/bootstrap.css";
import { createApp } from 'vue'
import App from './App.vue'
import router from './routes'
//jquery import
import "bootstrap/dist/js/bootstrap.js";
import Toaster from '@meforma/vue-toaster';

createApp(App).use(Toaster).use(router).mount('#app')